<template>
  <!-- 直接使用组件显示数据，不使用表格嵌套 -->
  <div class="filter-container">
    <select v-model="selectedFund" @change="filterData" class="filter-select">
      <option value="">板块/概念</option>
      <option v-for="(fundName, index) in fundNames" :key="index" :value="fundName">
        {{ fundName }}
      </option>
    </select>
  </div>

  <div v-for="(stocks, fundName) in filteredTableData" :key="fundName" class="fund-section">
    <h3><a :href="`https://www.iwencai.com/unifiedwap/result?w=${fundName}&querytype=stock`" target="_blank" class="stock-link">{{ fundName }}</a></h3>
    <table class="copyable-table">
      <thead>
        <tr>
          <th>标的名称</th>
          <th>标的代码</th>
          <th>7095报价</th>
          <th>香草报价</th>
          <th>雪球报价</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in stocks" :key="index">
          <td>
            <a :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${row.股票名称}`" target="_blank" class="stock-link">
              {{ row.股票名称 }}
            </a>
          </td>
          <td>
            <a :href="`/stock-detail?stock_code=${row.股票代码}`" target="_blank" class="stock-link">
              {{ row.股票代码 }}
            </a>
          </td>
          <td>
            <a :href="`/risky-search-form?searchQuery=${row.股票名称}+${row.股票代码}`" target="_blank" class="stock-link">
              7095报价
            </a>
          </td>
          <td>
            <a :href="`/stock-search-form?searchQuery=${row.股票名称}+${row.股票代码}`" target="_blank" class="stock-link">
              香草报价
            </a>
          </td>
          <td>
            <a :href="`/stock-search-form-xq?searchQuery=${row.股票名称}+${row.股票代码}`" target="_blank" class="stock-link">
              雪球报价
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="Object.keys(filteredTableData).length === 0" class="no-data">
    没有找到匹配的基金数据
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      tableData: {},
      selectedFund: '', // 选中的基金
      fundNames: [] // 基金名称列表
    }
  },
  computed: {
    filteredTableData() {
      if (!this.selectedFund) {
        return this.tableData;
      }

      const filtered = {};
      filtered[this.selectedFund] = this.tableData[this.selectedFund];
      return filtered;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await axios.get('/api/user_backup', {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`
          }
        });

        this.tableData = response.data;
        console.log(this.tableData);

        // 提取基金名称列表
        this.fundNames = Object.keys(this.tableData);
        console.log(this.fundNames);
        // 默认选择第一项（如果有数据）
        if (this.fundNames.length > 0) {
          this.selectedFund = this.fundNames[0];
        }

      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('数据加载失败');
      }
    },

    filterData() {
      // 这个方法会在选择改变时自动触发computed属性更新
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.filter-select {
  padding: 10px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  flex: 1;
  max-width: 500px;
  background-color: white;
  font-size: 14px;
}

.filter-select:focus {
  outline: none;
  border-color: #409eff;
}

.clear-button {
  padding: 10px 20px;
  background-color: #f5f5f5;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
}

.clear-button:hover {
  background-color: #ebebeb;
}

.fund-section {
  margin-bottom: 30px;
}

.fund-section h3 {
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}

.tabs-container {
  margin-bottom: 20px;
}

.filter-controls {
  margin-bottom: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
}

.table-wrapper {
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.copyable-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.copyable-table th,
.copyable-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.copyable-table th {

  font-weight: 600;
}

.copyable-table tr:hover td {
  background-color: #f8f9fa;
}

.stock-link {
  color: #409eff;
  text-decoration: none;
}

.stock-link:hover {
  text-decoration: underline;
}

.data-content {
  margin: 0;
  font-family: Monaco, Consolas, Courier, monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
}

.custom-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.query-button {
  padding: 10px 20px;
  transition: all 0.3s ease;
}

.query-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0,123,255,0.3);
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
}

::v-deep .type-selector .el-input__inner {
  border-radius: 20px;
  padding-left: 35px;
}

@media (max-width: 768px) {
  .table-wrapper {
    overflow-x: auto;
  }

  .filter-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .query-button {
    width: 100%;
  }

  .copyable-table {
    font-size: 14px;
  }

  .copyable-table th,
  .copyable-table td {
    padding: 8px 10px;
  }

  .filter-container {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-select {
    max-width: none;
    margin-bottom: 10px;
  }

  .clear-button {
    width: 100%;
  }
}
</style>
